import React, { useContext, useState, useEffect } from 'react';
import { Button, Typography, Divider, List, ListItem, ListItemText, Box, Card, CardContent, IconButton, Link, Drawer, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { eliminarItemCarrito, obtenerDetalleCarrito, obtenerMuestroCarrito, holaMundoAdmintour, obtenerReservasMotor, graboReservaEnAdmintour } from '../../services/motorService';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';
import RoomsContext from '../contexts/RoomsContext';
import useSession from '../../services/session';
import DialogRateDetail from './DialogRateDetail';
import Cookies from 'js-cookie';

const Summary = () => {
  const { cartItems, setCartItems } = useContext(RoomTypeRatePlanContext);
  const [selectedRoomsCount, setSelectedRoomsCount] = useState(0);
  const hotCod = Cookies.get('hotCod');
  const {updateRoom}= useContext(RoomsContext);
  const navigate = useNavigate();
  const sesion = useSession();

  const [open, setOpen] = useState(false);
  const [rateDetail, setRateDetail] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false); // Estado para controlar la apertura del Drawer
  const isMobileOrTablet = useMediaQuery((theme) => theme.breakpoints.down('md')); // Verifica si es móvil o tablet

  const handleConfirm = async () => {
    navigate(`/MotorReservasAdmintour/checkout`);
  };

  useEffect(() => {
    console.log('Cart items updated:', cartItems);
  }, [cartItems]);

  const handleDeleteItem = async (lineNumber) => {
    try {
      console.log("********************************************");
      console.log("********************************************");
      console.log("NRO DE LINEA BORRADA DEL CARRITO",lineNumber);
      console.log("********************************************");
      console.log("********************************************");
      updateRoom(lineNumber, false);
      await eliminarItemCarrito(hotCod, sesion, lineNumber);
      await fetchCart();
    } catch (error) {
      console.error('Error al eliminar el ítem del carrito:', error);
    }
  };

  const fetchCart = async () => {
    try {
      const cart = await obtenerMuestroCarrito(hotCod, sesion);
      console.log('Fetched cart:', cart);
      if (cart && cart.length > 0) {
        setCartItems(cart);
      } else {
        setCartItems([]);
        console.log('No cart data found');
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);
  
  const handleChartDetail = async (lineNumber) => {
    try {
      const detail = await obtenerDetalleCarrito(hotCod, sesion, lineNumber);
      setRateDetail(detail);
      console.log("Detalle de lo del carrito", detail);
      setOpen(true);
    } catch (error) {
      console.error('Error al obtener el detalle del carrito:', error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const toggleDrawer = (open) => () => {
    setOpenDrawer(open);
  };

  const totalImporte = cartItems
    ? cartItems.reduce((total, item) => total + parseFloat(item.CarritoItemTotal || 0), 0)
    : 0;

  const formatToCustomDate = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return format(utcDate, 'dd,MM,yyyy');
  };

  const formatTitleDate = () => {
    if (cartItems && cartItems.length > 0) {
      const checkinDate = new Date(cartItems[0].CarritoItemDesde);
      const checkoutDate = new Date(cartItems[0].CarritoItemHasta);

      const checkinDay = checkinDate.getUTCDate();
      const checkinMonth = checkinDate.getUTCMonth() + 1; // Los meses en JavaScript son 0 indexados
      const checkinYear = checkinDate.getUTCFullYear();
      const fullcheckinData = checkinDay + "/" + checkinMonth + "/" + checkinYear;

      const checkoutDay = checkoutDate.getUTCDate();
      const checkoutMonth = checkoutDate.getUTCMonth() + 1;
      const checkoutYear = checkoutDate.getUTCFullYear();
      const fullcheckoutData = checkoutDay + "/" + checkoutMonth + "/" + checkoutYear;

      return "Reserva del " + fullcheckinData + " al " + fullcheckoutData;
    }
    return "";
  }

  const obtengoCarritoMoneda = (carrito) => {
    if (carrito && carrito.length > 0) {
      return carrito[0].CarritoItemMoneda;
    }
    return "";
  };

  
  const drawerContent = (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Resumen
        </Typography>
        {cartItems && cartItems.length > 0 ? (
          <>
            <Typography variant="body2" color="textSecondary">
              {formatTitleDate()} {`/ ${Math.round((new Date(cartItems[0].CarritoItemHasta) - new Date(cartItems[0].CarritoItemDesde)) / (1000 * 60 * 60 * 24))} noche(s)`}
            </Typography>
            <Divider />
            <List>
              {cartItems.map((item, index) => {
                const fechaDesde = new Date(item.CarritoItemDesde);
                const fechaHasta = new Date(item.CarritoItemHasta);
                const isValidFechaDesde = !isNaN(fechaDesde.getTime());
                const isValidFechaHasta = !isNaN(fechaHasta.getTime());

                return (
                  <div key={item.CarritoItemLinea}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={
                          <>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                              {item.CarritoItemTipoHab}
                            </Typography>
                            <Typography variant="body1">
                              {item.CarritoItemTarifa}
                            </Typography>
                            <Link href="#" variant="body2" color="#007289" onClick={() => handleChartDetail(item.CarritoItemLinea)}>Detalle de la tarifa</Link>
                          </>
                        }
                        secondary={
                          <>
                            <Typography component="div" color="textSecondary" sx={{ marginTop: 2 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body2" color="textSecondary">
                                  {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                  {`${item.CarritoItemMoneda} ${item.CarritoItemTotal} `}
                                </Typography>
                              </Box>
                            </Typography>
                          </>
                        }
                      />
                      <IconButton edge="end" color="inherit" onClick={() => handleDeleteItem(item.CarritoItemLinea)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItem>
                    {index < cartItems.length - 1 && <Divider />}
                  </div>
                );
              })}
              <Divider />
              <Typography component="div" sx={{ marginTop: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Total
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  {obtengoCarritoMoneda(cartItems)} {totalImporte.toFixed(2)} 
                  </Typography>
                </Box>
              </Typography>
            </List>
          </>
        ) : (
          <Typography variant="subtitle1" color="textSecondary">
            No hay elementos en el carrito.
          </Typography>
        )}
      </CardContent>
      <CardContent>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            sx={{ width: '100%' }} // Establece el ancho del botón al 100%
            disabled={!cartItems || cartItems.length === 0}
          >
            Continuar
          </Button>
          
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <div>
      {isMobileOrTablet ? (
        <>
          <Drawer
            anchor="bottom"
            open={openDrawer}
            onClose={toggleDrawer(false)}
            sx={{ '& .MuiDrawer-paper': { padding: 2 } }}
          >
            {drawerContent}
          </Drawer>
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'white',
              zIndex: 10,
              boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
              padding: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <IconButton onClick={toggleDrawer(true)} sx={{ padding: 0 }}>
                <ExpandLessIcon />
              </IconButton>
              <Typography variant="h6" sx={{ marginLeft: 1 }}>
                {obtengoCarritoMoneda(cartItems)} {totalImporte.toFixed(2)}
              </Typography>
              <Button variant="contained" color="primary" onClick={handleConfirm} sx={{ marginLeft: 'auto' }}>
                Continuar
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        drawerContent
      )}

      <DialogRateDetail open={open} handleClose={handleClose} rateDetail={rateDetail} />
    </div>
  );
};

export default Summary;